import { NEXT_PUBLIC_CDN_URL } from '../../../../../appConfig';

const STATIC_IMAGE = `${NEXT_PUBLIC_CDN_URL}/public/static-images`;

export const HERO_BACKGROUND_ROWS: string[][] = [
  [
    `${STATIC_IMAGE}/126dc16b-6da4-413e-b615-3f88ec66bdfd.png?w=320&f=avif`,
    `${STATIC_IMAGE}/5bc1b420-675a-460e-ab94-97a0c12af070.jpg?w=320&f=avif`,
    `${STATIC_IMAGE}/21ff37ed-8306-4bc3-a4ae-a4b2e96241d9.jpg?w=320&f=avif`,
    `${STATIC_IMAGE}/fa346119-9eb3-4b12-925a-a0dd92d10a17.png?w=320&f=avif`,
    `${STATIC_IMAGE}/dfbea9f9-3fc9-4a97-9f84-c0fa70e14a5d.jpg?w=320&f=avif`,
    `${STATIC_IMAGE}/0ae3aff8-6f42-4084-b273-c9445ca11cd2.png?w=320&f=avif`,
    `${STATIC_IMAGE}/754f6349-4be8-496e-a8da-4aa6cd188be1.png?w=320&f=avif`,
    `${STATIC_IMAGE}/24241a7b-6c76-4dbd-82f1-5116bce2423d.jpg?w=320&f=avif`,
    `${STATIC_IMAGE}/7ab3fd01-da36-4d2e-ba88-4d8d4eb40122.png?w=320&f=avif`,
  ],
  [
    `${STATIC_IMAGE}/a2b09245-beac-4541-836c-5c62f1f5db57.png?w=320&f=avif`,
    `${STATIC_IMAGE}/57435f62-57ef-4e07-bab3-fbeeed2439f4.jpg?w=320&f=avif`,
    `${STATIC_IMAGE}/a32e1c0a-3ef9-4e66-a46e-1598c1d36f64.png?w=320&f=avif`,
    `${STATIC_IMAGE}/eed41f2e-bd36-4162-aca3-7515c16b6960.png?w=320&f=avif`,
    `${STATIC_IMAGE}/699112ca-585b-4c05-a3a8-ac3bc575ff33.png?w=320&f=avif`,
    `${STATIC_IMAGE}/c3fd83f5-754d-453d-8f37-4e931e66307b.png?w=320&f=avif`,
    `${STATIC_IMAGE}/76855f9a-1765-426d-b01d-aa6e2d562de5.png?w=320&f=avif`,
    `${STATIC_IMAGE}/dc09baab-e48d-4f99-8230-b284232d6f8e.png?w=320&f=avif`,
    `${STATIC_IMAGE}/b0bf364f-ef53-4c45-8653-75e5c3f99bb7.png?w=320&f=avif`,
  ],
];
